<template>
  <el-dialog
    :title="`Batch - ${batch.code}`"
    :visible.sync="setShow"
    :close-on-click-modal="false"
    width="50%"
  >
    <div class="batch-search">
      <el-input
        v-model="query"
        type="text"
        placeholder="Search by identifier"
        suffix-icon="ra-icon--search"
        class="search"
        :disabled="!pageData.length"
      />
    </div>
    <el-table
      :data="
        pageData.filter(
          data =>
            !query ||
            data.identifier.toLowerCase().includes(query.toLowerCase())
        )
      "
      v-loading="loading"
      :empty-text="'No items'"
      height="250"
    >
      <el-table-column fixed width="120" prop="status">
        <template slot="header">
          <span class="ra-table--header">
            Status
          </span>
        </template>
        <template slot-scope="scope">
          <el-tag
            :type="setType(scope.row.status && scope.row.status.name)"
            size="mini"
          >
            {{ scope.row.status && scope.row.status.label }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column fixed width="200" prop="identifier">
        <template slot="header">
          <span class="ra-table--header">
            Identifier
          </span>
        </template>
        <template slot-scope="scope">
          <p>{{ scope.row.identifier }}</p>
        </template>
      </el-table-column>
      <el-table-column
        width="150"
        v-for="key in dataKeys"
        :key="key"
        :prop="`data.${dataKeys[key]}`"
      >
        <template slot="header">
          <span class="ra-table--header">
            {{ key.replaceAll("_", " ") }}
          </span>
        </template>
        <template slot-scope="scope">
          <p>{{ scope.row.data[key] }}</p>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="created">
        <template slot="header">
          <span class="ra-table--header">
            Created
          </span>
        </template>
        <template slot-scope="scope">
          <p>
            {{ mFormatShortDate(scope.row.created_at, "d-m-y") }}
          </p>
        </template>
      </el-table-column>
      <el-table-column width="120" prop="modified">
        <template slot="header">
          <span class="ra-table--header">
            Modified
          </span>
        </template>
        <template slot-scope="scope">
          <p>
            {{ mFormatShortDate(scope.row.modified_at, "d-m-y") }}
          </p>
        </template>
      </el-table-column>
    </el-table>
    <ra-pagination
      v-if="dataFound"
      :from="from"
      :to="to"
      :total="total"
      :pageSize="pagination.perPage"
      :current-page.sync="currentPage"
    />
  </el-dialog>
</template>

<script>
import apiConstants from "@/apiConstants";

const paging = {
  perPage: 50,
  currentPage: 1,
  total: 0
};

export default {
  name: "UserImportationBatch",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    appCode: {
      type: String,
      default: ""
    },
    batch: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      query: "",
      loading: false,
      pageData: [],
      currentPage: 1,
      pagination: { ...paging }
    };
  },

  computed: {
    setShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit("update:show", value);
      }
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },

    from() {
      return this.pagination.perPage * (this.currentPage - 1);
    },

    total() {
      return this.pagination.total;
    },

    dataFound() {
      return !!this.pageData.length;
    },

    dataKeys() {
      return this.pageData.length ? Object.keys(this.pageData[0].data) : [];
    }
  },

  watch: {
    show() {
      if (this.show) {
        this.getBatchItems();
      }
    }
  },

  methods: {
    getPaginationParams() {
      const { currentPage, pagination } = this;
      return `page_size=${pagination.perPage}&page=${currentPage}`;
    },
    getBatchItems() {
      this.pageData = [];
      this.loading = true;
      const params = `&embeds=["status"]`;
      const apiUrl = `apps/${this.appCode}/users/import/batches/${this.batch.id}/data`;
      this.$http
        .post(
          apiUrl,
          {
            method: "GET",
            params: `${params}&${this.getPaginationParams()}`
          },
          {
            headers: {
              "data-baseurl-namespace": apiConstants.URLS.AUTHX
            }
          }
        )
        .then(response => {
          const resData = response.data;
          if (resData.status === "error") {
            this.handleErrors(resData);
            this.loading = false;
          } else {
            this.pageData = resData.list;
            this.pagination.total = resData.pagination.total_count;
            this.loading = false;
          }
        })
        .catch(() => {
          this.notification("Error", "An unknown error occurred", "danger");
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss">
.batch-search {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 30px;

  .el-input {
    max-width: 200px;

    &__inner {
      height: 32px;
    }
  }
}

.error {
  font-size: 0.75rem;
  color: var(--ra-red-primary);
}
</style>
